export default __webpack_public_path__ + "static/media/item_5@2x.1f8abd33.webp";